import React, { useState } from "react";

import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddDepots() {
  const history = useHistory();
  const classes = useStyles();
  const [depots_status, setDepots_status] = useState(1);
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [mac5code, setMAC5Code] = useState("");
  const [contact, setContact] = useState("");
  const EmpId = localStorage.getItem("EmpId");
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          โรงเก็บพัสดุ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Depots
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Depots
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{ depots_name: "", depots_no: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.depots_name || values.depots_name === "") {
              errors.depots_name = " * Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                no: values.depots_no,
                name: values.depots_name,
                status: 1,
                createId: EmpId,
                DepotsMAC5Code: mac5code,
                DepotsAddress: address,
                DepotsContactName: contact,
                DepotsEmail: email,
                DepotsTel: tel
              };

              api
                .post("api/depots/create", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่มโรงเก็บพัสดุสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Depots");
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                เพิ่มโรงเก็บพัสดุ
              </h6>
              <Grid container spacing={2} sx={{marginBottom:'20px'}}>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    name="depots_name"
                    label="DEPOTS NAME"
                    variant="outlined"
                    placeholder="DEPOTS NAME"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ width: "100%" }}
                    InputLabelProps={{ shrink: true }}
                    value={values.depots_name}
                    classes={{ root: !values.depots_name ? classes.customOutline : null }}
                    required
                  />
                  {/* {errors.depots_name &&
                    touched.depots_name &&
                    errors.depots_name} */}
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="DEPOTS  NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter DEPOTS  NO."
                    name="depots_no"
                    style={{
                      width: "100%",

                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.depots_no}
                    classes={{ root: !values.depots_no ? classes.customOutline : null }}
                    required
                  />
                  {/* {errors.depots_no && touched.depots_no && errors.depots_no} */}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="MAC5"
                    label="MAC-5 Code "
                    variant="outlined"
                    placeholder="Enter MAC-5 Code "
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setMAC5Code(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={mac5code}

                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}></Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    name="Address"
                    label="Address"
                    variant="outlined"
                    placeholder="Enter Address"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setAddress(e.target.value)
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={address}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Contact"
                    label="Contact Name"
                    variant="outlined"
                    placeholder="Enter Contact Name"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setContact(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={contact}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Email"
                    label="Email"
                    variant="outlined"
                    placeholder="Enter Email"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={email}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Telephone"
                    label="Telephone"
                    variant="outlined"
                    placeholder="Enter Telephone"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setTel(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={tel}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>

                  <FormControl fullWidth>
                    <InputLabel id="select_status-label">Status</InputLabel>
                    <Select
                      name="select_status"
                      id="select_status"
                      value={depots_status}
                      label="Status"
                      style={{
                        width: "100%",

                      }}
                      onChange={(e) => setDepots_status(e.target.value)}
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
